module.exports = __webpack_public_path__ + "static/media/line-columns.7f0f0f0b.svg";